/**
 * Created by Gaplo917 on 23/8/2017.
 */
import * as PIXI from "pixi.js";
import R from "../config/R"
import TWEEN from "@tweenjs/tween.js"

export default class FullScreenOverlay extends PIXI.Container {
  constructor(color = 0x000000, alpha = 0){
    super()

    const bgColor = new PIXI.Graphics()
    bgColor.beginFill(color)
    bgColor.drawRect(0, 0, R.dimen.width, R.dimen.height)

    this.addChild(bgColor)

    this.alpha = alpha
  }

}


// WEBPACK FOOTER //
// ./src/game/objects/FullScreenOverlay.js